/**
 * Export Timesheet Download Formatter.
 */
window.exportTimesheetDownloadFormatter = function(value, row) {
    let html = '';
    if (row.raw_status == "completed") {
        html += '<a href="/admin/exports/timesheets/download/'+row.id+'">';
        html += '<i class="fa fa-download"></i>';
        html += '</a>';
    }
    return html;
}
